// pages/Fete.js
import React, { useEffect } from 'react';
import Carousel from '../components/Carousel';

function Spectacle() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="fete-page">
      {/* Hero Section */}
      <div style={{
        padding: '80px 0 40px',
        textAlign: 'center',
        backgroundImage: 'url(/images/cover.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        width: '100%',
        marginLeft: 'calc(-50vw + 50%)',
        minHeight: '400px'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          zIndex: 1
        }}></div>

        <div className="container" style={{ position: 'relative', zIndex: 2, padding: '0 20px' }}>
          <style jsx>{`
            @media (max-width: 768px) {
              .fete-page > div:nth-child(1) {
                padding: 60px 0 30px !important;
                min-height: 300px !important;
              }
              .fete-page h1 {
                font-size: 2.5rem !important;
              }
            }
          `}</style>

          <img
            src="/images/Asset10.png"
            alt="Rights Expression Icon"
            style={{
              width: '80px',
              height: '80px',
              objectFit: 'contain'
            }}
          />

          <h1 style={{
            fontSize: '3.5rem',
            marginBottom: '20px',
            background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}>
            تعابير الحق
          </h1>

          <p style={{
            fontSize: '1.3rem',
            lineHeight: '1.9',
            marginBottom: '25px',
            color: 'var(--text-light)'
          }}>
        لوحات وإبداعات فنية للتعبير عن الحقوق والحريات
          </p>

          <div style={{
            background: 'var(--secondary-black)',
            padding: '20px 30px',
            borderRadius: '15px',
            borderRight: '4px solid var(--primary-orange)',
            marginBottom: '25px'
          }}>
            <p style={{ fontSize: '1.3rem', marginBottom: '10px' }}>
              <img src="/images/calandarv.png" className="tab-icon3-img" alt="Calendar" />
              <strong>تاريخ الحفل:</strong> 10 دجنبر 2025
            </p>
            <p style={{ fontSize: '1.3rem' }}>
              <img src="/images/location.png" className="tab-icon3-img" alt="Location" />
              <strong>المكان:</strong> سيحدد المكان قريبآ...
            </p>
          </div>
        </div>
      </div>

      {/* Main Content Section */}
      <div style={{ background: 'var(--secondary-black)', padding: '60px 0' }}>
        <div className="container">

          {/* Introduction */}
          <div style={{ marginBottom: '60px' }}>
            <h2 style={{
              fontSize: '2.5rem',
              marginBottom: '30px',
              textAlign: 'center',
              color: 'var(--white)'
            }}>
              من أجل فعلية الحقوق
            </h2>

            <div style={{
              background: 'var(--primary-black)',
              padding: '40px',
              borderRadius: '15px',
              border: '2px solid rgba(255, 107, 53, 0.3)',
              marginBottom: '40px'
            }}>
              <p style={{
                fontSize: '1.2rem',
                lineHeight: '2',
                color: 'var(--text-light)',
                marginBottom: '25px',
                textAlign: 'justify'
              }}>
              "تعابير الحق"، حفل سنويا يحتفي بالحقوق والتعبيرات، يتوج هذه السنة الحملة الوطنية لمناهضة العنف الرقمي ضد النساء والفتيات (25 نونبر – 10 دجنبر).
              </p>

              <p style={{
                fontSize: '1.2rem',
                lineHeight: '2',
                color: 'var(--text-light)',
                marginBottom: '25px',
                textAlign: 'justify'
              }}>
              حفل ختامي، في فضاء مفتوح، منفتح على تعابير الحق.
      </p>

              <p style={{
                fontSize: '1.2rem',
                lineHeight: '2',
                color: 'var(--text-light)',
                textAlign: 'justify'
              }}>
          الفن، بكل أشكاله وتعابيره، ليس مجرد تعبير جمالي وإبداعي، بل رافعة من أجل الحقوق والحريات ومساءلة العنف، وفتح مساحات جديدة للتفكير والوعي.    </p>
            </div>
          </div>

        

          <div className="section-separator"></div>

          {/* Call to Action */}
          <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '25px',
              color: 'var(--white)'
            }}>
              انضموا إلينا في الاحتفال
            </h3>
            <p style={{
              fontSize: '1.3rem',
              marginBottom: '30px',
              color: 'var(--text-light)',
              lineHeight: '1.8',
              maxWidth: '800px',
              margin: '0 auto 30px'
            }}>
              كونوا جزءا من هذا الحدث التاريخي وساهموا في بناء مجتمع خالٍ من العنف
            </p>


            <p style={{
              fontSize: '1.2rem',
              marginTop: '30px',
              color: 'var(--text-light)',
              fontStyle: 'italic'
            }}>
              معاً نعبر عن الحق | معاً نبني المستقبل
            </p>
          </div>
        </div>
      </div>

      <Carousel />
    </div>
  );
}

export default Spectacle;
